<template>
	<Dialog :titulo="is_new ? 'Cadastrar casa de repouso' : 'Editar casa de repouso'" btn_cancelar="Cancelar"
		:btn_acao="is_new ? 'Cadastrar' : 'Editar'" :btn_acao_disable="!habilitarBtnAcao" :btn_excluir="messagem_dialog_excluir.btn_excluir"
		@acao="submit()" @excluir="modal_excluir = true" @close="fechaModal()" :loading="salvando" :carregando="loading">

		<v-container fluid grid-list-lg class="pa-0">
			<Form :item="item" :campos="campos" />
		</v-container>

		<v-dialog persistent scrollable v-model="modal_excluir" transition="fade" max-width="340px">
			<transition>
				<Dialog v-if="modal_excluir" :titulo="messagem_dialog_excluir.titulo" :subtitulo="messagem_dialog_excluir.subtitulo"
					:btn_acao="messagem_dialog_excluir.btn_acao" btn_acao_class="error" btn_cancelar="Cancelar"
					@acao="excluir()" :loading="salvando" @close="modal_excluir = false" />
			</transition>
		</v-dialog>

		<v-dialog
			persistent
			scrollable
			v-model="discount_modal_is_enable"
			transition="fade"
			max-width="600px">
			<transition>
				<Dialog
					titulo="Porcentagem de desconto para os residentes"
					btn_acao="Confirmar"
					btn_acao_class="primary"
					btn_cancelar="Cancelar"
					:loading="salvando"
					:btn_acao_disable="!discount_confirmed"
					@close="discount_modal_is_enable = false"
					@acao="submeter()">

					<div class="text-center" style="max-width: 450px; margin: 0 auto;">
						<p style="color: red; font-weight: 700;font-size: 16px;">O desconto será aplicado a todos os medicamentos de todos os residentes dessa ILPI, sem a possibilidade de acréscimo adicional de desconto de forma individualizada.</p>
						<v-checkbox :input-value="discount_confirmed" @click.stop="discount_confirmed = !discount_confirmed" primary hide-details label="Declaro estar ciente de que o desconto será concedido a todos os residentes de ILPI."/>
					</div>
				</Dialog>
			</transition>
		</v-dialog>

		<v-dialog
			persistent
			scrollable
			v-if="canShowConfirmEdit"
			v-model="confirm_edit_modal"
			transition="fade"
			max-width="600px">
			<transition>

				<Dialog
					titulo="Atenção!"
					btn_acao="Confirmar"
					btn_acao_class="primary"
					btn_cancelar="Cancelar"
					:loading="salvando"
					@close="confirm_edit_modal = false"
					@acao="submeter()">
					<p style="font-size: 16px;">
						Estou ciente que, ao alterar essa informação, pode impactar {{subscriptionsRelated}} assinaturas associadas a essa ILPI.
						Se o endereço da assinatura estiver ligado ao endereço da casa e for editado, todos os endereços
						das assinaturas associadas serão modificados simultaneamente.
					</p>
				</Dialog>
			</transition>
		</v-dialog>
	</Dialog>
</template>

<script>
import { featureFlags } from '@Consts/feature-flags';
import { CRUDMixin } from '@Mixins/crud';
import { featureFlagsMixin } from '@Mixins/feature-flag';
import { AssinaturaPresenter } from '@Presenter/assinatura-presenter';
import { isEqual } from 'lodash';

export default {
	name: 'DialogCasaRepouso',
	mixins: [CRUDMixin, featureFlagsMixin],
	data: () => ({
		type: 'casa-repouso',
		fields_type: 'casa-repouso',
		discount_modal_is_enable: false,
		confirm_edit_modal: false,
		discount_confirmed: false,
		subscriptionsRelated: 0,
		item: {
			dias_antecedencia_entrega: 2,
			discount_percentage: 0
		}
	}),
	computed: {
		discountPercentIsValid() {
			return this.item.discount_percentage >= 0 && this.item.discount_percentage <= 100;
		},
		canShowConfirmEdit() {
			return (
				this.item.endereco_id && this.subscriptionsRelated > 0
			);
		}
	},
	methods: {
		setItem() {},
		onPresenterLoaded() {
			if (!this.is_new) {
				this.loading = true;
				this.requestShow(this.item_pai.id)
					.then(resp => {
						this.item = {
							...resp,
							discount_percentage: resp.porcentagem_desconto
						};

						AssinaturaPresenter.count({ endereco_id: resp.endereco_id }).then(response => {
							this.subscriptionsRelated = response.count;
						});
					})
					.finally(() => {
						this.loading = false;
					});
			}
		},
		createData() {
			return {
				...this.item,
				porcentagem_desconto: Number(this.item.discount_percentage),
				numero: Number(this.item.numero)
			};
		},
		submit() {
			if (!this.discountPercentIsValid) {
				this.$store.dispatch('SHOW_SNACKBAR', { color: 'error', message: 'A porcentagem de desconto deve ser um valor inteiro entre 0 e 100.' });
				return;
			}

			if (this.$store.getters.allow_apply_discount_ilpi && !this.is_new) {
				this.discount_modal_is_enable = true;
				return;
			}

			if (!this.is_new && this.canShowConfirmEdit) {
				this.confirm_edit_modal = true;
				return;
			}

			this.submeter();
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@Assets/css/settings.scss";
::v-deep .v-card__actions {
  background: #f5f5f5;
  padding: 16px 32px;
}

.align-center {
  display: flex;
  justify-content: center;
  align-items: center;

  .v-avatar {
    cursor: pointer;
    background: rgba(0, 0, 0, 0.06);
    transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);

    &:hover {
      background: rgba(0, 0, 0, 0.12);
    }

    &:active {
      background: rgba(0, 0, 0, 0.06);
    }
  }
}
</style>
